import { Box, VStack } from '@wegroup/design-system';
import React from 'react';

/** Used to correctly draw the special border for the matrix */
const DesktopBorderWrapper: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
  ...otherProps
}) => {
  return (
    <Box w="100%" borderTop="unset" borderBottom="unset" pr="6" {...otherProps}>
      <VStack
        h="100%"
        border="1px solid"
        borderColor="gray.100"
        borderTop="unset"
        borderBottom="unset"
      >
        {children}
      </VStack>
    </Box>
  );
};

export default DesktopBorderWrapper;
